import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_antd@3.0.0-beta.7@antd/es/pagination/index.js
// module id = null
// module chunks = 